import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import SignUpPageMobileProPanel1 from "./SignUpPageMobileProPanel1";
import SignUpPageMobileProPanel2 from "./SignUpPageMobileProPanel2";
import SignUpPageMobileProPanel3 from "./SignUpPageMobileProPanel3";
import { Dialog } from "@mui/material";
import { useAuthContext } from "../../../contexts/AuthContext";
import { useScaleMobile } from "../../../contexts/ScaleContextMobile";


const SignUpPageMobilePro = () => {
	const { scaleMobile } = useScaleMobile();
	const { t } = useTranslation();
	const {
		userInfo,
		loadUserInfoFromLocalStorage,
		setUserInfo,
		handleSignUpPro,
	} = useAuthContext();
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	
	const handleDialogClose = () => {
		setIsDialogOpen(false);
	};
	
	const handleConfirmDelete = () => {
		setUserInfo({
			...userInfo,
			documents: {
				companyRegistration: [],
				identityCard: [],
				identityCardBack: [],
				other: [],
			},
		});
		setIsDialogOpen(false);
		handleSignUpPro();
	};
	
	useEffect(() => {
		if (!userInfo?.contact?.email) {
			loadUserInfoFromLocalStorage('');
		}
	}, []);
	
	if (!userInfo?.contact?.email) {
		return <></>;
	}
	
	return (
		<div style={{ width: 390 }}>
			<div
				style={{
					width: 362,
					margin: '0 14px',
					background: '#ECECEC',
					borderRadius: 10,
					position: 'relative',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					paddingBottom: 22
				}}
			>
				<div
					style={{
						width: '80%',
						minHeight: 26,
						marginTop: 21,
						background: '#FF4D00',
						color: '#FFFFFF',
						letterSpacing: 0,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						padding: '4px 8px',
					}}
				>
					<div style={{
						fontSize: 16,
						fontWeight: 'bold',
						width: '100%',
						textAlign: 'center',
						lineHeight: '1.2'
					}}>
						{t('page2SignUp:signup_title')}
					</div>
				</div>
				<div
					style={{
						marginTop: 15,
						height: 15,
						fontSize: 12,
						fontWeight: 600,
						width: '100%',
						textAlign: 'center',
					}}
				>
					{t('page2SignUp:signup_steps')}
				</div>
				
				<SignUpPageMobileProPanel1 />
				<SignUpPageMobileProPanel2 />
				<SignUpPageMobileProPanel3 />
			</div>
			<div style={{ height: 20 }}></div>
			
			<Dialog
				open={isDialogOpen}
				onClose={handleDialogClose}
				PaperProps={{
					style: {
						width: 325,
						transform: `scale(${scaleMobile})`,
						transformOrigin: 'top',
						transition: 'transform 0.3s ease, padding 0.3s ease',
					},
				}}
			>
				<div
					style={{
						padding: '17px 0',
						width: 325,
						fontSize: 10,
						overflow: 'hidden',
						color: '#323E48',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
					}}
				>
					<div
						style={{
							width: 123,
							height: 25,
							background: '#FF4D00',
							color: '#FFFFFF',
							fontWeight: 'bold',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: 13,
							textTransform: 'uppercase',
						}}
					>
						{t('page2SignUp:dialog_attention')}
					</div>
					<div style={{ height: 15 }}></div>
					<div>
						{t('page2SignUp:dialog_provide_later')} <span
						style={{
							textDecoration: 'underline',
						}}>{t('page2SignUp:dialog_provide_later_underline')}</span> ?
					</div>
					<div style={{ height: 2 }}></div>
					<div
						style={{
							width: 70,
							height: 0.5,
							background: '#FF4D00',
						}}
					/>
					<div style={{ height: 24 }}></div>
					<div>
						{t('page2SignUp:dialog_clicked_provide_later')}
					</div>
					<div style={{
						textDecoration: 'underline',
						fontWeight: 500,
					}}>
						{t('page2SignUp:dialog_docs_deleted')}
					</div>
					<div style={{ height: 24 }}></div>
					<div style={{
						fontWeight: 'bold',
					}}>
						{t('page2SignUp:dialog_confirm_delete')}
					</div>
					<div style={{ height: 15 }}></div>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'center',
							gap: 31,
						}}
					>
						<button
							style={{
								width: 112,
								textAlign: 'center',
								height: 18,
								borderRadius: 5,
								boxShadow: 'inset 0px 3px 6px #00000029',
								background: '#ffffff',
								color: '#323E48',
								border: '2px solid #FF4D00',
								fontSize: 10,
								fontWeight: 'bold',
								cursor: 'pointer',
								textTransform: 'uppercase',
							}}
							onClick={handleConfirmDelete}
						>
							{t('page2SignUp:dialog_yes_delete')}
						</button>
						<button
							style={{
								width: 112,
								textAlign: 'center',
								height: 18,
								borderRadius: 5,
								backgroundColor: '#FF4D00',
								color: '#FFFFFF',
								border: 'none',
								fontSize: 10,
								fontWeight: 'bold',
								cursor: 'pointer',
								textTransform: 'uppercase',
							}}
							onClick={handleDialogClose}
						>
							{t('page2SignUp:dialog_no_cancel')}
						</button>
					</div>
				</div>
			</Dialog>
		</div>
	);
};

export default SignUpPageMobilePro;
